import { render, staticRenderFns } from "./compmain.vue?vue&type=template&id=28f5d46e&scoped=true"
import script from "./compmain.vue?vue&type=script&lang=js"
export * from "./compmain.vue?vue&type=script&lang=js"
import style0 from "./compmain.vue?vue&type=style&index=0&id=28f5d46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5d46e",
  null
  
)

export default component.exports